import { motion } from 'framer-motion';
import iconSandbox from '@/assets/icon-sandbox.jpg';
import iconCollaborate from '@/assets/icon-collaborate.jpg';
import iconSessionCollab from '@/assets/icon-session-collab.jpg';
import iconSkills from '@/assets/icon-skills.jpg';
import iconBot from '@/assets/icon-bot.jpg';
import iconApprove from '@/assets/icon-approve.jpg';
import bgTech1 from '@/assets/bg-tech-1.jpg';

const steps = [
  {
    image: iconSandbox,
    title: 'Define your goal',
    desc: 'Describe the outcome — agents handle the breakdown.',
  },
  {
    image: iconCollaborate,
    title: 'Agents self-organize',
    desc: 'Planner, builder, reviewer, and QA agents coordinate autonomously.',
  },
  {
    image: iconSessionCollab,
    title: 'Collaborate in real time',
    desc: 'Humans and AI agents share one live workspace.',
  },
  {
    image: iconSkills,
    title: 'Inject domain skills',
    desc: 'Load your playbooks, standards, and guardrails.',
  },
  {
    image: iconBot,
    title: 'Execute with oversight',
    desc: 'Agents work through approval gates — nothing ships unchecked.',
  },
  {
    image: iconApprove,
    title: 'Review and ship',
    desc: 'Audit every action, approve results, and deploy with confidence.',
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="section-padding relative overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={bgTech1} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" />
      </div>
      <div className="mx-auto max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            How agentic AI works on Tasking.tech
          </h2>
          <p className="mt-2 text-muted-foreground max-w-2xl mx-auto">
            Describe what you need once — autonomous agents plan, execute, and deliver while you
            stay in control at every step.
          </p>
        </motion.div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-6">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="glass-card-hover group overflow-hidden rounded-2xl"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={step.image}
                  alt={step.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute bottom-2 left-2 flex h-7 w-7 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                  {i + 1}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground">{step.title}</h3>
                <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
